/**
 * Estado derivado de una auditoría: el `audit_state` "Planificada" se
 * desglosa según si hay auditor asignado y fecha de planificación.
 *
 *   - Planificada + sin auditor                  → «Sin asignar»
 *   - Planificada + auditor + sin planning_date  → «Asignada»
 *   - Planificada + auditor + planning_date      → «Planificada»
 *   - cualquier otro estado (Finalizada, Cancelada, etc.) → as-is
 *
 * Compartido entre /audits, /planning-groups/show y el detalle de finca.
 * No depende de ningún tipado concreto — acepta un objeto con
 * `audit_state_name`, `auditor_user` y `planning_date`.
 */
export type AuditLike = {
  audit_state_name?: string | null;
  auditor_user?: number | null;
  planning_date?: string | null;
};

export const getAuditDisplayState = (audit: AuditLike): string => {
  const raw = (audit?.audit_state_name || "").trim();
  if (!raw) return "";
  const lowered = raw.toLowerCase();
  if (!lowered.includes("planific")) return raw;
  if (audit.auditor_user == null) return "Sin asignar";
  if (!audit.planning_date) return "Asignada";
  return raw;
};

/** Color del Tag de antd para el estado derivado. */
export const colorForAuditDisplayState = (display: string): string => {
  const lowered = display.toLowerCase();
  if (display === "Sin asignar") return "gold";
  if (display === "Asignada") return "cyan";
  if (lowered.includes("cancel")) return "red";
  if (lowered.includes("finaliz")) return "green";
  if (lowered.includes("checke")) return "purple";
  if (lowered.includes("sin informe")) return "orange";
  if (lowered.includes("con informe")) return "gold";
  if (lowered.includes("no realiz")) return "default";
  if (lowered.includes("planific")) return "blue";
  return "default";
};
